import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { Tag, Target, Layers, Grid3X3, AlertTriangle, HelpCircle } from 'lucide-react';
import type { CommitmentSourceConfig } from '../../shared/types';

const iconMap: Record<string, LucideIcon> = {
  tag: Tag,
  target: Target,
  layers: Layers,
  'grid-3x3': Grid3X3,
  grid3x3: Grid3X3,
  'alert-triangle': AlertTriangle,
  alerttriangle: AlertTriangle,
};

export function getSourceIcon(iconName: string | undefined, size = 14): React.ReactElement {
  const Icon = iconMap[(iconName || 'tag').toLowerCase()] || HelpCircle;
  return <Icon size={size} />;
}

const builtinDefaults: Record<string, { displayName: string; icon: string }> = {
  fixVersion: { displayName: 'Fix Version', icon: 'tag' },
  label: { displayName: 'Label', icon: 'tag' },
  component: { displayName: 'Component', icon: 'layers' },
  cluster: { displayName: 'Cluster', icon: 'grid-3x3' },
  affectedVersion: { displayName: 'Affected Version', icon: 'alert-triangle' },
};

export function getSourceDisplay(
  sourceType: string,
  configs?: CommitmentSourceConfig[]
): { displayName: string; icon: string } {
  const cfg = configs?.find((c) => c.key === sourceType);
  if (cfg) return { displayName: cfg.displayName, icon: cfg.icon };
  return builtinDefaults[sourceType] ?? { displayName: sourceType, icon: 'tag' };
}

/** Prefer API-resolved catalog label (e.g. Forecast "Target Version") over raw source keys. */
export function getSourceDisplayWithOverride(
  sourceType: string,
  displayNameOverride?: string | null,
  configs?: CommitmentSourceConfig[]
): { displayName: string; icon: string } {
  const base = getSourceDisplay(sourceType, configs);
  const trimmed = displayNameOverride?.trim();
  if (trimmed) return { ...base, displayName: trimmed };
  return base;
}
